/* Delegated handlers keep specifications usable after product section updates. */
(() => {
  if (window.productSpecsModalReady) return;
  window.productSpecsModalReady = true;

  function initTriggers(scope) {
    scope.querySelectorAll('[data-action="open-specs"]').forEach((trigger) => {
      trigger.setAttribute("aria-haspopup", "dialog");
    });
  }

  initTriggers(document);
  document.addEventListener("shopify:section:load", (event) => initTriggers(event.target));

  function setExpanded(dialog, expanded) {
    document.querySelectorAll(`[aria-controls="${CSS.escape(dialog.id)}"]`).forEach((trigger) => {
      trigger.setAttribute("aria-expanded", String(expanded));
    });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[aria-controls]");
    const dialog = trigger && document.getElementById(trigger.getAttribute("aria-controls"));
    if (dialog?.matches("dialog.product-specs-modal")) {
      event.preventDefault();
      trigger.setAttribute("aria-haspopup", "dialog");
      if (typeof dialog.showModal === "function") dialog.showModal();
      else dialog.setAttribute("open", "");
      document.body.classList.add("product-specs-modal-open");
      setExpanded(dialog, true);
      return;
    }

    const backdrop = event.target;
    if (!backdrop.matches("dialog.product-specs-modal")) return;
    const rect = backdrop.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) backdrop.close();
  });

  // The close event does not bubble, so observe it in the capture phase.
  document.addEventListener(
    "close",
    (event) => {
      if (!event.target.matches("dialog.product-specs-modal")) return;
      document.body.classList.remove("product-specs-modal-open");
      setExpanded(event.target, false);
    },
    true,
  );
})();
